module.exports = __webpack_public_path__ + "static/media/pro-detail-img5.408577ac.jpg";